var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyTypeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3994 15L18.3994 15.95",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3491 20.875C12.0616 21.1125 14.1895 21.24 15.8994 22C17.6094 22.76 18.1619 23.7625 18.3994 24C18.8744 23.6042 19.6139 22.585 21.3238 21.825C23.0338 21.065 24.0946 20.875 24.4113 20.875",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3994 24V28.0374",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3994 16.2375C13.7952 16.8708 14.442 17.8994 17.8619 17.8994C21.2818 17.8994 22.5037 16.7915 22.8995 16.2373",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2993 9C12.8535 10.1083 13.9143 12.7049 13.7243 14.2249C13.4868 16.1248 11.5868 18.0247 11.3493 21.1122C11.1593 23.5821 12.141 26.2578 12.5368 27.5245",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7219 9C23.1677 10.1083 22.1069 12.7049 22.2969 14.2249C22.5344 16.1248 24.1744 18.0247 24.4119 21.1122C24.6019 23.5821 24.2957 26.7334 23.8999 28",
    stroke: "#3F3F3F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyTypeIcon);
export default __webpack_public_path__ + "static/media/bodyTypeIcon.1f6b3869d6facedac4a3eaaed6267093.svg";
export { ForwardRef as ReactComponent };